import React from 'react';

const FallBack = () => {
	return (
		<div className='d-flex justify-content-center align-items-center flex-grow-1 w-100 min-vh-100'>
			<div className='spinner-grow text-primary color-mode' role='status'>
				<span className='visually-hidden'>Loading...</span>
			</div>
		</div>
	);
};

export default FallBack;
